export default "__VITE_ASSET__0lT$peQF__"